export default function handleCartGoals(element: HTMLElement) {
  const type = element.getAttribute("data-helium-cart-goal-type");
  if (!type) {
    console.log("No valid 'data-helium-cart-goal-type' attribute found.");
    return;
  }
  let data = element.getAttribute(`data-helium-cart-goal-${type}`);
  if (!data) {
    console.log(`No valid 'data-helium-cart-goal-${type}' attribute found.`);
    return;
  }
  data = JSON.parse(data);
  if (type === "order-value") {
    data = data?.sort((a, b) => a.value - b.value);
  } else {
    data = data?.sort((a, b) => a.count - b.count);
  }

  window.helium.ui.renderCartGoals({ element, type, data });
}
